<form #elbridgeForm [action]="transferLink" method="post" enctype="multipart/form-data" target="_blank">
  <input type="hidden" name="version" value="2.0">
  <input type="hidden" name="country" value="CH">
  <input type="hidden" name="language" value="deu">
  <input type="hidden" name="hookUrl" [value]="transferLink">
  <input type="hidden" name="target" value="_self">
  <input type="hidden" name="json" value="result">
</form>
